<div class="loading-container" *ngIf="loading">
	<div class="lds-facebook">
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>

<div class="form-container configure" *ngIf="!loading">
	<div class="group">
		<div class="user-message">NOTE: The following configurations will supersede the global settings. </div>
		<div class="group-container">
			<div class="message" (click)="showCommunicationExpanded = !showCommunicationExpanded">
				<em *ngIf="!showCommunicationExpanded" class="fas fa-angle-down expand"></em>
				<em *ngIf="showCommunicationExpanded" class="fas fa-angle-up expand"></em>
				<div class="group-title">E-mail Communication Settings</div>
			</div>
			<div class="data" [ngClass]="{'hidden': !showCommunicationExpanded}">
				<div class="help-text">The values input below will be used on the last screen of the requesting wizard and can be modified prior to sending each request.</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container">
					<label for="dropboxSignDefaultSubject" class="input-label">Default E-mail Subject</label>
					<div class="help-text">The subject of the e-mail that will be sent to the signers.</div>
					<input type="text" maxlength="255" id="dropboxSignDefaultSubject" [(ngModel)]="procoreUserConfig.dropboxSignDefaultSubject">
					<div *ngIf="procoreUserConfig.dropboxSignDefaultSubject" class="characters-remaining">{{ 255 - procoreUserConfig.dropboxSignDefaultSubject.length }} characters remaining</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container">
					<label for="dropboxSignDefaultMessage" class="input-label">Default E-mail Message</label>
					<div class="help-text">The custom message in the e-mail that will be sent to the signers.</div>
					<textarea maxlength="5000" id="dropboxSignDefaultMessage" [(ngModel)]="procoreUserConfig.dropboxSignDefaultMessage" class="client-info-textarea"></textarea>
					<div *ngIf="procoreUserConfig.dropboxSignDefaultMessage" class="characters-remaining">{{ 5000 - procoreUserConfig.dropboxSignDefaultMessage.length }} characters remaining</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container">
					<label for="dropboxSignDefaultCC" class="input-label">Default E-mail CC</label>
					<div class="help-text">A comma-separated list of e-mail addresses that will be copied on every signature request.</div>
					<input type="text" maxlength="255" id="dropboxSignDefaultCC" [(ngModel)]="procoreUserConfig.dropboxSignDefaultCC">
					<div *ngIf="procoreUserConfig.dropboxSignDefaultCC" class="characters-remaining">{{ 255 - procoreUserConfig.dropboxSignDefaultCC.length }} characters remaining</div>
				</div>
			</div>
		</div>
		<div class="button-container">
			<button type="button" class="btn" (click)="updateConfigurations()">Save</button>
			<button type="button" class="btn secondary" (click)="cancelConfigurations()">Cancel</button>
		</div>
	</div>
</div>